import { useId, useState } from 'react'
import { CaretDown } from '@phosphor-icons/react'

export default function ReportSection({ title, subtitle, children, defaultExpanded = true }) {
  const [open, setOpen] = useState(defaultExpanded)
  const id = useId()
  return (
    <section className="report-section">
      <button
        className="report-section__heading"
        type="button"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(!open)}
      >
        <strong>{title}</strong>
        {subtitle && <span>{subtitle}</span>}
        <CaretDown size={16} className={open ? '' : 'is-collapsed'} aria-hidden="true" />
      </button>
      <div id={id} hidden={!open} className="ubiqua-motion-enter">
        {children}
      </div>
    </section>
  )
}
